const linkAdditionalNavi = document.querySelector('.link_additional_navi');
const dropdownAdditionalWrapper = document.querySelector('.navigationdropdown__wrapper_challenges.desktop_nav');
const dropdownChallengesInner = document.querySelector('.navigationdropdown__wrapper_challenges .navigationdropdown__inner');

linkAdditionalNavi.addEventListener('mouseenter', function () {
  dropdownAdditionalWrapper.classList.remove('navigationdropdown__wrapper_challenges--hidden');
});

linkAdditionalNavi.addEventListener('mouseleave', function () {
  dropdownAdditionalWrapper.classList.add('navigationdropdown__wrapper_challenges--hidden');
});

dropdownChallengesInner.addEventListener('mouseenter', function () {
  dropdownAdditionalWrapper.classList.remove('navigationdropdown__wrapper_challenges--hidden');
});

dropdownChallengesInner.addEventListener('mouseleave', function () {
  dropdownAdditionalWrapper.classList.add('navigationdropdown__wrapper_challenges--hidden');
});

const menuOpener = document.querySelector('.additional_menu_opener');
const additionalModal = document.querySelector('.mobile_products_container.additional_modal');

menuOpener.addEventListener('click', function () {
    additionalModal.classList.add('opened');
});